import { IIngridApi, IShipwallet, RootState } from '@checkout/state';
import * as cx from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { checkoutApi } from 'ys-analytics';
import messages from '../../../i18n/base-en';
import { MessageBox, Widget } from '../../presentational';
import { updatePaymentFieldsRequest } from './../../../reducers/checkout';
import CentraCheckoutScript from './CentraCheckoutScript';
import * as Styles from './IngridWidget2.scss';

const isEqual = require('react-fast-compare');

interface IOwnProps {
  readOnly?: boolean;
}

interface IConnectedProps {
  shipwallet?: IShipwallet;
  currency: string;
}

interface IConnectetDispatchProps {
  updatePaymentFieldsRequest: typeof updatePaymentFieldsRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class IngridWidget2 extends React.Component<Props, {}> {

  updateFields = (event: any) => {
    const { updatePaymentFieldsRequest: updatePaymentFields } = this.props;
    const { address, additionalFields } = event.detail;

    // tslint:disable-next-line:no-console
    console.log('dispatched: "centra_checkout_callback"', event.detail);

    updatePaymentFields({
      suspendIgnore: additionalFields.suspendIgnore.shipwallet !== undefined && additionalFields.suspendIgnore.shipwallet,
      // shippingAddress: address, // probably needs to change to this, because Adlibris Go has a problem with shipwallet snippet after this request
      address,
      additionalFields
    });
  }

  addEventsWhenLoaded = () => {
    if (!!window._sw) {
      window._sw(function (api: IIngridApi) {
        api.on('loaded', () => {
          // tslint:disable-next-line:no-console
          console.log('ingrid widget has been loaded');
          CentraCheckoutScript().addEvents();
        });
      });
    }
  }

  shouldComponentUpdate(nextProps: Props) {
    return !isEqual(this.props.shipwallet, nextProps.shipwallet);
  }

  componentDidMount() {
    const { eeCheckoutSteps } = checkoutApi;
    const { currency } = this.props;
    try {
      eeCheckoutSteps.shipwalletLoad(currency);
    } catch (err) {
      // tslint:disable-next-line:no-console
      console.error('Enhanced Ecommerce error: ', err);
    }
    CentraCheckoutScript().addEvents();
    window.addEventListener('centra_checkout_callback', this.updateFields);
  }

  componentWillUnmount() {
    window.removeEventListener('centra_checkout_callback', this.updateFields, false);
  }

  render() {
    const { shipwallet, readOnly, intl } = this.props;
    const { formatMessage } = intl;
    const isAvailable = shipwallet && shipwallet.deliveryOptionsAvailable;

    const IngridWidget2ClassNames = cx({
      [Styles.readOnly]: readOnly,
    });

    return (
      <div className={IngridWidget2ClassNames}>
        {shipwallet && shipwallet.snippet && <Widget snippet={shipwallet.snippet} evaluateDelay={500} onUpdate={this.addEventsWhenLoaded} />}
        {!isAvailable && (
          <div className={Styles.message}><MessageBox withBorder={true} type="error" message={formatMessage(messages.ingrid_not_available_error)} /></div>
        )}
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      shipwallet: state.checkout.selection.pluginFields && state.checkout.selection.pluginFields.shipwallet,
      currency: state.checkout.selection.currency,
    }),
    {
      updatePaymentFieldsRequest,
    }
  ),
)(IngridWidget2);
